import storeInfo from '../store'

export const getPDFUrl = (state: ReturnType<typeof storeInfo.store.getState>) => state.files.pdfUrl

export const getPDFUrlDirect = () => storeInfo.store.getState().files.pdfUrl

